import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
interface VeeState {
  veeRuleWorkflow: any[];
}

// initial states
const initialState: VeeState = {
  veeRuleWorkflow: [],
};

const reducers = {
  setVeeRuleWorkflow: (state: VeeState, action: PayloadAction<any[]>) => {
    state.veeRuleWorkflow = action.payload;
  },
};

// creating vee slice
const VeeSlice = createSlice({
  name: "vee",
  initialState,
  reducers,
});

// exporting actions
export const { setVeeRuleWorkflow } = VeeSlice.actions;

export default VeeSlice.reducer;
